import RestService from '../services/rest';

async function getNewUsersParams() {
  return RestService.getAuthenticated('newUsersParams');
}

async function updateNewUsersParams(params) {
  return RestService.putAuthenticated('panel/newUsersParams/update', params);
}

export default {
  getNewUsersParams,
  updateNewUsersParams,
};
